import {Component, Inject} from '@angular/core'
import {MatTableDataSource} from '@angular/material/table'
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog'

export interface FieldValue {
  fieldName: string
  fieldValue: string
}

export interface AddEditWhitelistDetails {
  title: string
  ruleName: string
  ruleMnemonic: string
  fieldValues: FieldValue[]
}


@Component({
  templateUrl: 'analysis-list-add-edit-dialog.component.html',
  styleUrls: ['./analysis-list-add-edit-dialog.component.scss'],
})
export class AnalysisListAddEditRowDialogComponent {

  displayedColumns = ['fieldName', 'fieldValue']
  dataSource: MatTableDataSource<FieldValue>

  constructor(public dialogRef: MatDialogRef<AnalysisListAddEditRowDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AddEditWhitelistDetails) {
    this.dataSource = new MatTableDataSource<FieldValue>(data.fieldValues)
  }

  cancel() {
    this.dialogRef.close(undefined)
  }
}
